import styled from 'styled-components';
import breakpoints from '@/theme/constants/breakpoints';
import {sizePx} from '@/theme/helpers/size';
import typography from '@/theme/typography';
import colors from '@/theme/constants/colors';
import Accordion from '@/molecules/Accordion/Accordion';
import {StyledAccordionBody} from '@/molecules/Accordion/styles';

export const StyledTitle = styled.p`
  ${typography.Subtitle1}
  margin-bottom: ${sizePx(10)};
`;

export const StyledYear = styled.p`
  ${typography.Body1}
  color: ${colors.darkBlue25};
  margin: ${sizePx(10)} 0 ${sizePx(3)};
`;

export const StyledDescription = styled.p`
  ${typography.Body1}
  margin: ${sizePx(3)} 0 0;
`;

export const StyledBody = styled.div`
  > ${StyledYear}:first-child {
    margin: ${sizePx(3)} 0;
  }
`;

export const StyledAccordion = styled(Accordion)`
  ${StyledAccordionBody} > ${StyledYear}:first-child {
    margin: 0 0 ${sizePx(3)};
  }

  @media only screen and ${breakpoints.device.m} {
    display: none;
  }
`;

export const StyledAboutEducation = styled.div`
  display: none;

  @media only screen and ${breakpoints.device.m} {
    display: block;
  }
`;
